import { render, staticRenderFns } from "./ImportarMatriz.vue?vue&type=template&id=406a1b05&scoped=true&"
import script from "./ImportarMatriz.vue?vue&type=script&lang=js&"
export * from "./ImportarMatriz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406a1b05",
  null
  
)

export default component.exports